import { forIn, omit, without } from "lodash";
import { DRAG_AND_DROP_CONSTANTS } from "./constants";

export const bulkDelete = ({ entities, selectedPages }) => {
  let updatedData = { ...entities };

  forIn(selectedPages, (values, columnId) => {
    const { pageIds } = entities.columns[columnId];
    const restPages = omit(updatedData.pages, values);

    updatedData = {
      ...updatedData,
      pages: restPages,
    };

    if (
      pageIds.length === values.length &&
      columnId !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE
    ) {
      // remove column if empty
      const restColumns = omit(updatedData.columns, [columnId]);
      const columnOrder = without(updatedData.columnOrder, columnId);

      return (updatedData = {
        ...updatedData,
        columns: restColumns,
        columnOrder,
      });
    }

    const filtredPages = without(
      updatedData.columns[columnId].pageIds,
      ...values
    );

    updatedData = {
      ...updatedData,
      columns: {
        ...updatedData.columns,
        [columnId]: {
          ...updatedData.columns[columnId],
          pageIds: filtredPages,
        },
      },
    };
  });

  return updatedData;
};
